export default __webpack_public_path__ + "static/media/1908.6081a9ae.png";